const initSearchToggle = () => {
    const triggers = document.getElementsByClassName('js-searchTrigger');
    for (let i = 0, len = triggers.length; i < len; i++) {
        const trigger = triggers[i];
        trigger.addEventListener('click', e => {
            if (document.body.className.indexOf('search-isOpen') === -1) {
                document.body.className += ' search-isOpen';
            } else {
                document.body.className = document.body.className
                    .split('search-isOpen')
                    .join('')
                    .split('  ')
                    .join(' ');
            }

            e.preventDefault();
        });
    }
};

initSearchToggle();
